// extracted by mini-css-extract-plugin
export default {"aboutTitle":"styles_aboutTitle__VVJ7F","certLabel":"styles_certLabel__fLbF5","certStatus":"styles_certStatus__8X6Bu"};